import "../UserProfile.scss";
import { getUserDetails, UpdatePassword } from "../Services/UserProfile.sevice";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { FormikState, useFormik } from "formik";
import { UpdatePasswordInitialvalue, UpdatePasswordSchema } from "../Schema/UserProfile.schema";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { UpdatePasswordInterface } from "../Interfaces/Userprofile.interface";
import { useNavigate } from "react-router-dom";
import { AppRouteURL, AppRouteURLwithChilds } from "@Constants/app-route-url.constant";


export const ChangePasswordIndex = () => {
  const Navigation = useNavigate();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userInfo,setUserInfo]=useState<any>();

  const { handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, setFieldValue, setValues, resetForm } = useFormik({
    initialValues: UpdatePasswordInitialvalue,
    validationSchema: UpdatePasswordSchema,

    onSubmit: (e, { resetForm }) => {

      updatepass(e, resetForm)


    }
  })
  const fetchUserDetails = async () => {
    try {
      const response = await getUserDetails();
      if (response.success && response.data?.[0]) {
        const userData = response.data[0];
        setUserInfo(userData);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  
  useEffect(()=>{
    if(userInfo?.RegisteredFrom==="Social Login Api"){
      Navigation("/");
    }
  },[userInfo])
  let content = ""
  const updatepass = (e: UpdatePasswordInterface, resetForm: (nextState?: Partial<FormikState<{ oldPassword: string; newPassword: string; re_newPassword: string; }>> | undefined) => void) => {
    const passwordobj = {
      'oldPassword': e.oldPassword,
      'newPassword': e.newPassword
    }
    UpdatePassword(passwordobj).then((response: APIResponse) => {
      //  if(response.ResponseType === "PASSWORD_NOT_MATCHED"){
      if (response.ResponseType === APIStatus.SUCCESS) {
        resetForm()
        toast.success(response.StatusMsg)
      }
      else {
        toast.error(response.StatusMsg)
      }

    }).catch((error: any) => {
      console.log(error)
      toast.error(error.response.data.StatusMsg)
    })

  }


  return (
    <>
    {userInfo &&  <div className="user-profile-right-container">
        <div className="user-act-header">
          <div className="usr-prf-heading">Change Password</div>
          <div className="user-prf-para tw-mt-2">
            We recommend that you set a strong password that is at least 8{" "}
            <br /> characters long and includes a mix of letter, number and
            special character
          </div>
        </div>
        <p>{content}</p>

        <form onSubmit={handleSubmit}>
          <div className="profile-input-card tw-bg-white tw-shadow-lg tw-rounded-2xl px-4 pb-4 pt-2 mt-2">
            <div className="input-form-card">
              <div className="form-label-log">Current Password <span className="mandiatory-star">*</span></div>
              <div className="password-box">
                <input
                  type={showOldPassword ? 'text' : 'password'}
                  placeholder="Enter Current password"
                  name="oldPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.oldPassword}
                />
                <span className="show-psswd" onClick={() => setShowOldPassword(!showOldPassword)}>{showOldPassword ? 'Hide' : 'Show'}</span>
              </div>
              {errors.oldPassword && touched.oldPassword ? (
                <p className="text-red-500">{errors.oldPassword}</p>
              ) : null}
            </div>
            {/* <a className="forget-pass-span">
              <span
                onClick={() =>
                  Navigation(
                    AppRouteURL.AUTH +
                      AppRouteURLwithChilds.AUTH.childrens.FORGOT_PASSWORD.path
                  )
                }
              >
                Forgot password?
              </span>
            </a> */}

            <div className="input-form-card ">
              <div className="form-label-log">New Password <span className="mandiatory-star">*</span></div>
              <div className="password-box">
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  placeholder="Enter New password"
                  name="newPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.newPassword}
                />
                <span className="show-psswd" onClick={() => setShowNewPassword(!showNewPassword)}>{showNewPassword ? 'Hide' : 'Show'}</span>
              </div>
              {errors.newPassword && touched.newPassword ? (
                <p className="text-red-500">{errors.newPassword}</p>
              ) : null}
            </div>

            <div className="input-form-card">
              <div className="form-label-log">Confirm Password <span className="mandiatory-star">*</span></div>
              <div className="password-box">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="Re-enter new password"
                  name="re_newPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.re_newPassword}
                />
                <span className="show-psswd" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>{showConfirmPassword ? 'Hide' : 'Show'}</span>
              </div>
              {errors.re_newPassword && touched.re_newPassword ? (
                <p className="text-red-500">{errors.re_newPassword}</p>
              ) : null}
            </div>

            <div className="tw-text-center tw-mt-9">
              <button className="ia-btn ia-btn-primary tw-w-full sm:tw-w-auto tw-px-6" type="submit">
                Update Password
              </button>
            </div>
          </div>
        </form>
      </div>}
     
    </>
  );
};